import { toDateTime } from "./toDateTime";
export const dateTimeFormatted = (stringDate, toFormat, { fromFormat, defaultValue = "Не указано" } = {}) => {
    if (!stringDate) {
        return defaultValue;
    }
    const date = toDateTime(stringDate, { fromFormat });
    if (date.isValid) {
        return date.toFormat(toFormat);
    }
    return defaultValue;
};
